<template>
  <div class="bg-white">
    <form class="hideBlockParent">
          <div class="form-group mb-4">
            
            <div>
              <label>Select Company</label>
              <!-- <img src="help.svg" :style="{height: '20px', marginLeft:'10px'}" alt="Tooltip" data-toggle="tooltip" data-trigger="hover" title="You can change the project owner later"> -->
            </div>

            <div class="input-group mb-3 d-flex flex-row">
              <el-select
                v-model="selectedCompany"
                value-key="id"
                filterable
                remote
                class="input-normal select-danger"
                style="flex:9"
                placeholder="Search Company"
                :remote-method="search"
                @change="onCompanySelected"
                :loading="searching"
                allow-create
                
              >
                <el-option
                  v-for="item in foundCompanies"
                  :key="item.id"
                  :label="item.website"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div v-if="false" class="input-group-append" style="flex:1">
                <button
                  id="inviteForm5"
                  class="btn btn-success"
                  type="button"
                  data-toggle="collapse"
                  href="#assignForm5"
                  role="button"
                  aria-expanded="false"
                  @click="
                    createCompanyExpanded = !createCompanyExpanded;
                    selectedCompany = null;
                  "
                >
                  <i class="fas fa-user-plus" />
                </button>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col mt-2">
                <div
                  id="assignForm5"
                  class="collapse multi-collapse"
                  
                >
                  <div class="card card-body">
                    <div class="row">
                      <div class="col-sm-12 form-group">
                        <label>Company Website</label>
                        <input
                          v-model="companyInvite.website"
                          type="text"
                          class="form-control"
                          
                        />
                      </div>
                      <!-- <div class="col-sm-12 form-group">
                        <label>ABN</label>
                        <input
                          v-model="companyInvite.abn"
                          type="text"
                          class="form-control"
                          name="email"
                          placeholder=""
                        />
                      </div> -->

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <base-button
              type="primary"
              class="col my-4 btn-block"
              @click="handleSubmit"
              >{{ createCompanyExpanded ? "Create & Set Company" : "Set" }}</base-button
            >

        
          </div>
        </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { required, minLength, between, email } from "vuelidate/lib/validators";
export default {
  name: "AssignCompany",
  props: ["editId","data"],
  data() {
    return {
      users: [],
      queryText: "",
      createCompanyExpanded: this.data && this.data.website != null,
      companyInvite: this.data || {},
      searching: false,
      foundCompanies: [],
      selectedCompany: this.data,
      project: {
        user_owner: {},
        users: []
      },
      editTitle: "Create Project"
    };
  },
  validations: {
    
  },

  watch: {
    async editId(newVal, oldVal) {
      console.log(oldVal, newVal, "9++++++++++");
      if (newVal != oldVal) {
        let role = this.roles.filter(r => r.name == "OWNER")[0];
        let owner = { ...this.profile };
        if (newVal) {
          this.fetchProject(newVal);
        }
      }
    }
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("common", ["roles"]),
    filteredUsers() {
      return this.users.filter(res => {
        if (this.queryText != "") {
          let fullName =
            res.first_name.toLowerCase() + " " + res.last_name.toLowerCase();
          return fullName.includes(this.queryText.toLowerCase());
        } else {
          return false;
        }
      });
    }
  },

  async mounted() {
   
  },

  methods: {
    ...mapActions("user", ["fetchAllUsers", "inviteClient", "inviteUser", "updateProfileInfo", "fetchUserInfoAction"]),
    ...mapActions("project", [
      "createProject",
      "updateProject",
      "fetchSingleProject"
    ]),
    ...mapActions("common", ["fetchRoles", "searchCompanies", "createCompany","updateCompany"]),
    ...mapMutations(["setGanttRender"]),

    

    search(query) {
      if (query !== "") {
        this.searching = true;
        this.searchCompanies(query).then(
          r => {
            console.log(r.data)
            this.foundCompanies = r.data;
            this.searching = false;
          },
          e => {
            console.log(e, "Error fetching company")
            this.searching = false;
          }
        );
      } else {
        this.foundCompanies = [];
        this.searching = false;
      }
    },

    async onCompanySelected(value) {
      let req=null
      if(typeof value === "string") {
        if(!this.isValidHttpUrl(value)) {
            this.$snack.success("Invalid Website")
            return false
          }

          let body = {
          // name: this.companyInvite.name,
          // abn: this.companyInvite.abn,
          website: this.companyInvite.website
        }
        //now create company
        let res = await this.createCompany(body)
        console.log(res, "created")

        req = {...this.profile, company_id: res.data.id}
      

      } else {
        req = {...this.profile, company_id: value.id}
      }

      try {
        let res = await this.updateProfileInfo(req)
        this.$snack.success("Company assigned successfully")
        await this.fetchUserInfoAction()
        //this.$emit('closeClicked')
      } catch(e) {
        console.log(e)
        this.$snack.success("Could not assign company to user")
      }

    },

    
    

    async handleSubmit() {
      let req = {}
      if (this.selectedCompany == null) {
        //now form user model from companyInvite
        if(this.companyInvite.website) {
          if(!this.isValidHttpUrl(this.companyInvite.website)) {
            this.$snack.success("Invalid Website")
            return false
          }
        }
        let body = {
          // name: this.companyInvite.name,
          // abn: this.companyInvite.abn,
          website: this.companyInvite.website
        }
        //now create company
        let res = await this.createCompany(body)
        console.log(res, "created")
        req = {...this.profile, company_id: res.data.id}
      } else {
        req = {...this.profile, company_id: this.selectedCompany.id}
      }

      try {
        let res = await this.updateProfileInfo(req)
        this.$snack.success("Company assigned successfully")
        await this.fetchUserInfoAction()
        this.$emit('closeClicked')
      } catch(e) {
        console.log(e)
        this.$snack.success("Could not assign company to user")
      }
      
      

    },

    isValidHttpUrl(string) {
      let url;

      try {
        url = new URL(string);
      } catch (_) {
        return false;  
      }

      return url.protocol === "http:" || url.protocol === "https:";
    }
  }
};
</script>

<style lang="sass"></style>
